// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_dl-3";
export var flatBottomCorners = "_dl-5";
export var productImage = "_dl-0";
export var quantityContainer = "_dl-2";
export var quantityHeader = "_dl-6";
export var tooltip = "_dl-1";
export var wrapAndEllipsesOverflow = "_dl-4";